import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";

import { MoveResult } from "./app/move";

function ResultSection({
  title,
  items,
}: {
  title: string;
  items: Array<{ key: string; detail?: string }>;
}) {
  if (!items.length) return null;
  return (
    <section>
      <Typography variant="subtitle2">{title}</Typography>
      <List dense>
        {items.map(({ key, detail }) => (
          <ListItem key={key} disableGutters>
            <ListItemText primary={key} secondary={detail} />
          </ListItem>
        ))}
      </List>
    </section>
  );
}

function MoveResultDialog({
  result,
  onClose,
}: {
  result: MoveResult | null;
  onClose: () => void;
}) {
  return (
    <Dialog open={Boolean(result)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Move results</DialogTitle>
      <DialogContent>
        <ResultSection
          title={`Moved (${result?.succeeded.length ?? 0})`}
          items={(result?.succeeded ?? []).map((key) => ({ key }))}
        />
        <ResultSection
          title={`Skipped (${result?.skipped.length ?? 0})`}
          items={(result?.skipped ?? []).map((key) => ({ key }))}
        />
        <ResultSection
          title={`Failed (${result?.failed.length ?? 0})`}
          items={(result?.failed ?? []).map(({ source, error }) => ({
            key: source,
            detail: error.message,
          }))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoveResultDialog;
